<div class="h-full">
  <div class="aligner-between min-h-[40px] py-1 px-3">
    <div class="text-standard-heading font-semibold flex items-center">
      History for&nbsp;<span *ngIf="!!params?.filePath"
        ><code class="break-all">{{ params?.filePath }}</code
        >&nbsp;in</span
      >&nbsp;
      <y42-git-branch-name-display class="inline-block" [name]="state.activeBranch.name"> </y42-git-branch-name-display>
    </div>
    <button class="close-btn" mat-icon-button mat-dialog-close>
      <fa-icon class="fs-8 text-gray-700" [icon]="['fal', 'times']"></fa-icon>
    </button>
  </div>
  <div class="w-full" style="height: calc(100% - 50px)">
    <y42-logo-loader
      *ngIf="state.loading.commits || state.loading.activeBranch"
      class="center-absolute"
      [widthInPixel]="70"
      [attr.data-test]="'git-history-dialog-loading-spinner'"
    >
    </y42-logo-loader>

    <as-split *ngIf="!state.loading.commits" [useTransition]="true" [gutterSize]="6" class="border-common">
      <as-split-area [size]="25" [minSize]="10" class="flex flex-col">
        <ng-container *ngIf="{ withBranch: branchToCompareWith$ | async } as compare">
          <ng-container *ngIf="!params?.filePath">
            <y42-git-branch-filter
              [label]="'Select branch to compare...'"
              class="block px-2 border-bottom git-branch-selector"
              [preventFocusOnClear]="true"
              [value]="compare.withBranch?.name || ''"
              (focusin)="showBranchList = true"
              (cleared)="selectBranchToCompare(null)"
            >
              <fa-icon prefix class="top-1 relative fs-08" [icon]="['fal', 'code-branch']"></fa-icon>
            </y42-git-branch-filter>

            <mat-button-toggle-group
              *ngIf="!showBranchList && compare.withBranch"
              class="flex toggle-group-deep-style"
              [formControl]="compareDirectionFC"
            >
              <mat-button-toggle class="flex-1" value="behind"
                >Behind ({{ compare.withBranch.aheadBehindStatus.behind }})
              </mat-button-toggle>
              <mat-button-toggle class="flex-1" value="ahead"
                >Ahead ({{ compare.withBranch.aheadBehindStatus.ahead }})
              </mat-button-toggle>
            </mat-button-toggle-group>
          </ng-container>

          <div class="flex-1 h-0 relative">
            <mat-progress-bar class="absolute" mode="indeterminate" *ngIf="resettingScroll"></mat-progress-bar>
            <div *ngIf="!resettingScroll && compare.withBranch && !activeCommit" class="center-absolute">
              Your branch is up to date with the compared branch ({{ compare.withBranch.name }})
            </div>
            <y42-git-branch-list
              *ngIf="showBranchList"
              [branches]="state.branches"
              (branchClicked)="selectBranchToCompare($event)"
            >
              <ng-template [templateContext]="branchItemContext" let-branch>
                <span class="flex-1 min-w-0 truncate"
                  >{{ branch.name }}<span class="fs-06" *ngIf="!branch.published">&nbsp;(local)</span></span
                >
                <span class="ml-auto shrink-0 fs-06 text-gray-700">
                  <span>
                    {{ branch.aheadBehindStatus.behind }}
                    <fa-icon [icon]="['fal', 'long-arrow-down']"></fa-icon>
                  </span>
                  <span class="ml-1">
                    {{ branch.aheadBehindStatus.ahead }}
                    <fa-icon [icon]="['fal', 'long-arrow-up']"></fa-icon>
                  </span>
                </span>
              </ng-template>
            </y42-git-branch-list>

            <y42-git-commits-list
              *ngIf="!showBranchList"
              [commits]="state.commits"
              [(active)]="activeCommit"
              (loadMore)="nextBatch()"
            ></y42-git-commits-list>
          </div>
        </ng-container>
      </as-split-area>

      <as-split-area [size]="75" class="flex flex-col" (click)="showBranchList = false">
        <y42-git-commit-details
          class="flex flex-col h-full relative"
          [loading]="resettingScroll"
          [commit]="activeCommit!"
          [filePath]="params?.filePath"
          (checkedOut)="closeDialog()"
        ></y42-git-commit-details>
      </as-split-area>
    </as-split>
  </div>
</div>
